import { FETCHING_COVERAGE, FETCHED_COVERAGE, SET_COVERAGE, ADD_PROJECTS, CLEAR_ALL } from "../actions/constants";
import defaults from "./defaults";

const coverageReducer = (state = defaults.coverage, { type, payload }) => {
  switch (type) {
    case SET_COVERAGE:
      return { ...state, by_project: { ...state.by_project, [payload.project_id]: payload.coverage } };
    case FETCHING_COVERAGE:
      return { ...state, fetching: payload };
    case FETCHED_COVERAGE:
      return { ...state, fetched: { ...state.fetched, [payload.project_id]: new Date() } };
    case ADD_PROJECTS:
      return { ...state, fetched: {}, fetching: false, by_project: {} };
    case CLEAR_ALL:
      return defaults.coverage;
    default:
      return state;
  }
};

export default coverageReducer;
